<script setup lang="ts" name="CargoTrackerDetails">
import BaseAlert from '~/components/BaseAlert.vue';
import BillOfLadingCard from '~/components/BillOfLadingCard.vue';
import BillOfLadingInformation from '~/components/BillOfLadingInformation.vue';
import OrganisationShipmentPortContactsCard from '~/components/OrganisationShipmentPortContactsCard.vue';
import VesselMap from '~/components/VesselMap.vue';
import VoyageTracker from '~/components/VoyageTracker.vue';

import type {
  IBillOfLadingInfo,
  ISharedContactCard,
  IVesselVoyageData,
  IVoyageTrackerStep,
} from '~/types';

const {
  portsAndDatesTooltip,
  serviceState,
  bolInformation,
  portsAndDates,
  portContacts,
  vesselVoyageData,
} = defineProps<{
  serviceState: Record<string, unknown>;
  bolInformation?: IBillOfLadingInfo;
  portsAndDatesTooltip?: string;
  portsAndDates?: IVoyageTrackerStep[];
  portContacts?: ISharedContactCard;
  vesselVoyageData?: IVesselVoyageData;
}>();
</script>

<template>
  <BaseAlert type="info" class="rounded drop-shadow">
    All dates, vessels and port calls are subject to change without notice
  </BaseAlert>

  <BillOfLadingInformation v-bind="bolInformation" />

  <div class="grid grid-rows-2 gap-2 sm:grid-cols-2 sm:grid-rows-1">
    <BillOfLadingCard
      title="Ports & Dates"
      tooltipTitle=""
      :tooltipDescription="portsAndDatesTooltip"
    >
      <div>
        <VoyageTracker
          v-for="port in portsAndDates"
          :key="port.id"
          v-bind="port"
        />
      </div>
    </BillOfLadingCard>

    <BillOfLadingCard title="Vessel Location">
      <div class="h-full pb-4">
        <VesselMap :serviceState="serviceState" :mapData="vesselVoyageData" />
      </div>
    </BillOfLadingCard>
  </div>

  <div class="rounded-md shadow">
    <OrganisationShipmentPortContactsCard v-bind="portContacts" />
  </div>
</template>
